import { render, staticRenderFns } from "./TransferGroups.vue?vue&type=template&id=4e13631a&"
import script from "./TransferGroups.vue?vue&type=script&lang=ts&"
export * from "./TransferGroups.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports